// src/utils/seedProducts.js
// Run this script once to populate your Firebase with initial products
// You can execute it from a temporary admin page or from browser console

import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../services/firebase/firebaseconfig";
import React, { useState } from 'react';

const sampleProducts = [
  {
    name: 'Bureau Executive Premium',
    category: 'Bureaux',
    description: 'Bureau en bois massif avec finition premium. Design élégant et moderne.',
    price: 45000,
    oldPrice: 52000,
    image: 'https://images.unsplash.com/photo-1595428774223-ef52624120d2?w=800',
    rating: 4.8,
    reviews: 124,
    stock: 'in-stock',
    stockCount: 15,
    badge: 'Bestseller',
    material: 'Bois',
    color: 'Marron',
    brand: 'Premium Office',
    features: ['Garantie 2 ans', 'Livraison gratuite']
  },
  {
    name: 'Chaise Ergonomique Pro',
    category: 'Chaises',
    description: 'Chaise de bureau ergonomique avec soutien lombaire optimal.',
    price: 28000,
    oldPrice: null,
    image: 'https://images.unsplash.com/photo-1580480055273-228ff5388ef8?w=800',
    rating: 4.6,
    reviews: 89,
    stock: 'in-stock',
    stockCount: 32,
    badge: 'Nouveau',
    material: 'Tissu',
    color: 'Noir',
    brand: 'ErgoComfort',
    features: ['Réglable', 'Confort max']
  },
  {
    name: 'Table de Réunion Moderne',
    category: 'Tables',
    description: 'Table de réunion spacieuse pour 8 personnes. Design contemporain.',
    price: 68000,
    oldPrice: 75000,
    image: 'https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=800',
    rating: 4.9,
    reviews: 56,
    stock: 'low-stock',
    stockCount: 3,
    badge: 'Promo',
    material: 'Métal',
    color: 'Blanc',
    brand: 'ModernSpace',
    features: ['Installation offerte', 'Design moderne']
  },
  {
    name: 'Armoire de Rangement',
    category: 'Rangements',
    description: 'Armoire spacieuse avec serrure de sécurité et 4 étagères.',
    price: 35000,
    oldPrice: null,
    image: 'https://images.unsplash.com/photo-1594026112284-02bb6f3352fe?w=800',
    rating: 4.5,
    reviews: 72,
    stock: 'in-stock',
    stockCount: 21,
    badge: null,
    material: 'Métal',
    color: 'Gris',
    brand: 'SecureStore',
    features: ['Sécurisé', 'Grande capacité']
  },
  {
    name: 'Bureau Compact Design',
    category: 'Bureaux',
    description: 'Bureau compact idéal pour petits espaces. Fonctionnel et élégant.',
    price: 32000,
    oldPrice: null,
    image: 'https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?w=800',
    rating: 4.4,
    reviews: 45,
    stock: 'in-stock',
    stockCount: 18,
    badge: null,
    material: 'Bois',
    color: 'Naturel',
    brand: 'CompactLiving',
    features: ['Gain d\'espace', 'Montage facile']
  },
  {
    name: 'Fauteuil Gaming Deluxe',
    category: 'Chaises',
    description: 'Fauteuil gaming avec LED RGB et soutien complet du corps.',
    price: 38000,
    oldPrice: 45000,
    image: 'https://images.unsplash.com/photo-1598550476439-6847785fcea6?w=800',
    rating: 4.7,
    reviews: 203,
    stock: 'in-stock',
    stockCount: 12,
    badge: 'Hot',
    material: 'Cuir',
    color: 'Noir',
    brand: 'GamePro',
    features: ['LED RGB', 'Ultra confortable']
  },
  {
    name: 'Bureau Standing Desk',
    category: 'Bureaux',
    description: 'Bureau réglable en hauteur électrique. Travaillez debout ou assis.',
    price: 85000,
    oldPrice: null,
    image: 'https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=800',
    rating: 4.9,
    reviews: 167,
    stock: 'low-stock',
    stockCount: 5,
    badge: 'Nouveau',
    material: 'Métal',
    color: 'Blanc',
    brand: 'HealthDesk',
    features: ['Électrique', 'Mémoire positions']
  },
  {
    name: 'Bibliothèque Murale',
    category: 'Rangements',
    description: 'Bibliothèque design à fixation murale. Optimise l\'espace.',
    price: 24000,
    oldPrice: null,
    image: 'https://images.unsplash.com/photo-1594026112284-02bb6f3352fe?w=800',
    rating: 4.3,
    reviews: 38,
    stock: 'in-stock',
    stockCount: 28,
    badge: null,
    material: 'Bois',
    color: 'Blanc',
    brand: 'WallStore',
    features: ['Fixation murale', 'Design élégant']
  }
];

export const seedProducts = async () => {
  try {
    console.log("Starting to seed products...");
    const productsRef = collection(db, "products");
    
    let successCount = 0;
    let errorCount = 0;

    for (const product of sampleProducts) {
      try {
        await addDoc(productsRef, {
          ...product,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        });
        successCount++;
        console.log(`✓ Added: ${product.name}`);
      } catch (error) {
        errorCount++;
        console.error(`✗ Error adding ${product.name}:`, error);
      }
    }

    console.log(`\n=== Seeding Complete ===`);
    console.log(`Successfully added: ${successCount} products`);
    console.log(`Errors: ${errorCount}`);
    
    return {
      success: true,
      successCount,
      errorCount,
      message: `Added ${successCount} products successfully`
    };
  } catch (error) {
    console.error("Seeding error:", error);
    return {
      success: false,
      error: error.message,
      message: "Failed to seed products"
    };
  }
};

// Helper component to run the seed function (for admin use only)
export const SeedButton = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleSeed = async () => {
    if (window.confirm("Are you sure you want to seed the database? This will add sample products.")) {
      setLoading(true);
      const res = await seedProducts();
      setResult(res);
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <button 
        onClick={handleSeed} 
        disabled={loading}
        style={{
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: loading ? 'not-allowed' : 'pointer'
        }}
      >
        {loading ? 'Seeding...' : 'Seed Products to Firebase'}
      </button>
      
      {result && (
        <div style={{ marginTop: '20px', padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}>
          <h3>{result.success ? '✓ Success' : '✗ Error'}</h3>
          <p>{result.message}</p>
          {result.successCount && <p>Products added: {result.successCount}</p>}
          {result.errorCount > 0 && <p>Errors: {result.errorCount}</p>}
        </div>
      )}
    </div>
  );
};

export default seedProducts;